import { createContext } from "react";
import { EntityPageState } from "./EntityPageProvider.types";

export const EntityPageContext =
  createContext<EntityPageState | null>(null);
